@import '../../../../theme/colors';

.addTag {
  display: flex;
  align-items: center;
  > div {
    width: 290px;
    margin-right: 20px;
  }
}
.tags {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.tagListWrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  .tableContainer {
    height: 100%;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    > table {
      margin-top: 16px;
    }
  }
  .tableHead {
    .tableRow {
      border-bottom: 2px solid $lightGrey;
    }
    th {
      font-family: var(--font-family__heading);
      font-size: 12px;
      color: $neutral-600;
      padding: 14px;
      padding-bottom: 8px;
    }
  }
  .tableRow {
    border-bottom: 2px solid $neutral-200;
    td {
      padding: 14px;
      font-family: var(--font-family__body);
      &.userCell {
        padding: 0;
      }
      p {
        position: relative;
        margin: 0;
        line-height: 20px;
        max-height: 40px;
        overflow: hidden;
        &.truncated {
          &::after {
            content: '...';
            position: absolute;
            bottom: 0;
            right: 0;
            background-color: white;
          }
        }
      }
    }
    .colorColumn {
      width: 18px;
      padding-right: 0;
      .colorLabel {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: $neutral-600;
      }
    }
    .nameColumn {
      width: 148px;
      input {
        padding: 6px;
        font-family: var(--font-family__body);
        font-size: 12px;
        line-height: 17px;
      }
      label {
        font-family: var(--font-family__body);
        font-size: 12px;
        line-height: 17px;
        transform: translate(0.5em, 5px);
      }
    }
    .usersColumn {
      padding-left: 0;
    }
    .actionsColumn {
      width: 60px;
    }
  }
}

.userForm {
  margin: 40px 0;
}

.modalActionFooter {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  button {
    width: 70px;
  }
}
